export default __webpack_public_path__ + "static/executive-6a7425870438e237c80786f698ed996a.jpg";